module.exports = __webpack_public_path__ + "img/92a872f0014c3b7e2cdb34b0dc294c58.06a82e59.jpg";